/* El Croquis · motor del buscador (generado desde bd-web/src/lib/search-core.js; no editar aquí). */
(function () {
// Motor de búsqueda de El Croquis: lo usan elcroquis.es (assets/ec-search.js) y la Biblioteca Digital.
// Trabaja sobre el índice de /public/search-index (números, obras y textos con sus índices) sin más llamadas.
// Sin dependencias. Busca sin tildes ni mayúsculas, por palabras completas o empezadas, tolera una errata
// en palabras largas, reconoce números («236», «n. 236», «el croquis 236») y años («2015»).

const STOP = new Set('de del la las el los lo y e en a al con por para un una unos unas su sus the of and in on at for an to by o u'.split(' '));

function fold(s) {
  return String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}
function words(s) {
  return fold(s).split(/[^a-z0-9]+/).filter(Boolean);
}
function nums(s) {
  return (String(s || '').match(/\d+/g) || []).map((x) => String(parseInt(x, 10)));
}
function yearsOf(s) {
  const m = String(s || '').match(/(\d{4})(?:\D+(\d{4}))?/);
  if (!m) return null;
  const a = +m[1], b = m[2] ? +m[2] : a;
  return [Math.min(a, b), Math.max(a, b)];
}
// Distancia de edición (con transposición), cortando en cuanto supera max
function dist(a, b, max) {
  if (Math.abs(a.length - b.length) > max) return max + 1;
  const n = b.length;
  let pp = null, p = Array.from({ length: n + 1 }, (_, j) => j);
  for (let i = 1; i <= a.length; i++) {
    const c = [i];
    let best = i;
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      let v = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + cost);
      if (pp && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, pp[j - 2] + 1);
      c.push(v);
      if (v < best) best = v;
    }
    if (best > max) return max + 1;
    pp = p; p = c;
  }
  return p[n];
}

// Lugares: las obras llevan la ubicación en inglés («London, United Kingdom»); así «Londres» también las encuentra.
const ALIAS_PAIRS = 'londres:london, nueva york:new york, tokio:tokyo, kioto:kyoto, japon:japan, espana:spain, suiza:switzerland, alemania:germany, francia:france, belgica:belgium, holanda:netherlands, paises bajos:netherlands, reino unido:united kingdom, inglaterra:england, escocia:scotland, irlanda:ireland, estados unidos:usa, italia:italy, dinamarca:denmark, suecia:sweden, noruega:norway, finlandia:finland, brasil:brazil, grecia:greece, polonia:poland, turquia:turkey, marruecos:morocco, corea:korea, singapur:singapore, bombay:mumbai, pekin:beijing, moscu:moscow, viena:vienna, colonia:cologne, ginebra:geneva, basilea:basel, lisboa:lisbon, oporto:porto, copenhague:copenhagen, estocolmo:stockholm, atenas:athens, roma:rome, venecia:venice, florencia:florence, napoles:naples, bruselas:brussels, amberes:antwerp, gante:gent, brujas:bruges, la haya:hague, roterdam:rotterdam, hamburgo:hamburg, francfort:frankfurt, burdeos:bordeaux, marsella:marseille, estrasburgo:strasbourg, edimburgo:edinburgh, baleares:balearic, cataluna:catalonia, andalucia:andalusia, pais vasco:basque, varsovia:warsaw, praga:prague, seul:seoul, sudafrica:south africa'.split(', ');
const ALIAS = new Map();
for (const pair of ALIAS_PAIRS) {
  const [a, b] = pair.split(':');
  if (a === b) continue;
  const aw = a.split(' '), bw = b.split(' ');
  // Una palabra por cada lado: «londres» ⇄ «london»; si son varias, la última («nueva york» → «york»)
  const ka = aw[aw.length - 1], kb = bw[bw.length - 1];
  if (ka !== kb) { if (!ALIAS.has(ka)) ALIAS.set(ka, kb); if (bw.length === 1 && !ALIAS.has(kb)) ALIAS.set(kb, ka); }
}

const GROUP = { n: 'num', v: 'num', o: 'obra', w: 'obra', c: 'obra', t: 'texto', x: 'texto' };
const KIND_BONUS = { n: 4, v: 2, o: 2, t: 2, w: 0, x: 0, c: -2 };

function createSearch(data) {
  const E = (data && data.e) || [];
  const cats = (data && data.cats) || {};
  const byH = new Map();
  E.forEach((e, i) => { e._i = i; if (e.h) byH.set(e.h, e); });
  E.forEach((e) => {
    e._p = e.p ? byH.get(e.p) || null : null;
    e._g = GROUP[e.k] || 'obra';
    e._y = yearsOf(e.y || (e._p && e._p.y));
    e._n = e.k === 'n' ? nums(e.n) : [];
  });

  // Índice invertido: palabra -> [documento, peso]
  const post = new Map();
  const put = (i, text, w) => {
    if (!text) return;
    for (const tk of words(text)) {
      if (STOP.has(tk)) continue;
      let m = post.get(tk);
      if (!m) post.set(tk, (m = new Map()));
      if ((m.get(i) || 0) < w) m.set(i, w);
    }
  };
  const issueNum = new Map(), childNum = new Map();
  const pushMap = (map, k, i) => { let a = map.get(k); if (!a) map.set(k, (a = [])); a.push(i); };
  for (const e of E) {
    const i = e._i;
    put(i, e.t, 10); put(i, e.te, 9);
    put(i, e.a, 8);
    (e.q || []).forEach((x) => put(i, x, 6));
    put(i, e.l, 4);
    (e.g || []).forEach((c) => put(i, cats[c] || c, 3));
    if (e._p) { put(i, e._p.t, 3); put(i, e._p.te, 3); }
    put(i, e.d, 1);
    e._n.forEach((n) => pushMap(issueNum, n, i));
    if (e._p && e._p.k === 'n') nums(e._p.n).forEach((n) => pushMap(childNum, n, i));
  }
  const terms = [...post.keys()].sort();

  // Personas y estudios: nombre -> recuentos por tipo
  const people = new Map();
  const addPerson = (name, e) => {
    if (!name || name.length < 3 || name.length > 80) return;
    const key = fold(name).replace(/[^a-z0-9]+/g, ' ').trim();
    if (!key) return;
    let p = people.get(key);
    if (!p) people.set(key, (p = { name, key, words: key.split(' '), num: 0, obra: 0, texto: 0 }));
    p[e._g]++;
  };
  for (const e of E) {
    if (e.k === 'n') addPerson(e.t, e);
    else if (e.k === 'o' || e.k === 't' || e.k === 'x') addPerson(e.a, e);
    (e.q || []).forEach((x) => addPerson(x, e));
  }
  const peopleList = [...people.values()];

  function lookup(t) {
    const out = [];
    let lo = 0, hi = terms.length;
    while (lo < hi) { const mid = (lo + hi) >> 1; if (terms[mid] < t) lo = mid + 1; else hi = mid; }
    for (let i = lo; i < terms.length && out.length < 500; i++) {
      const term = terms[i];
      if (!term.startsWith(t)) break;
      if (term === t) out.push([term, 1]);
      else if (t.length >= 2) out.push([term, t.length >= 4 ? 0.8 : 0.65]);
    }
    return out;
  }
  function fuzzy(t) {
    const max = t.length >= 8 ? 2 : 1;
    const out = [];
    for (const term of terms) {
      if (Math.abs(term.length - t.length) > max) continue;
      if (term[0] !== t[0] && term[1] !== t[1]) continue;
      const d = dist(t, term, max);
      if (d <= max) out.push([term, d === 1 ? 0.55 : 0.4]);
    }
    return out;
  }

  /**
   * Busca. Devuelve { items: [{e, score}], tokens, approx, numberHit, people }.
   * opts.filter(e) descarta entradas (por ejemplo, las que no están en la Biblioteca).
   */
  function search(q, opts) {
    opts = opts || {};
    const raw = String(q || '').trim();
    if (!raw) return { items: [], tokens: [], approx: false, people: [] };
    const f = fold(raw);
    let qt = words(raw);
    const meaningful = qt.filter((t) => !STOP.has(t) && !/^(el|croquis|n|no|num|numero|nr|vol|volumen|issue)$/.test(t));
    const isNumQuery = /^(?:(?:el\s*)?croquis|ec|n|no|n[ºo°]|num(?:ero)?|vol(?:umen)?|issue)?\s*[.#º°]?\s*\d{1,3}(?:\s*[/+\-]\s*\d{1,3})?$/.test(f);
    qt = isNumQuery ? nums(f) : qt.filter((t) => !STOP.has(t));
    if (!qt.length) qt = meaningful.length ? meaningful : words(raw);
    if (!qt.length) return { items: [], tokens: [], approx: false, people: [] };

    const total = new Map(), hits = new Map(), matched = [];
    qt.forEach((t, ti) => {
      const cand = new Map();
      const bump = (i, s) => { if ((cand.get(i) || 0) < s) cand.set(i, s); };
      const isNum = /^\d+$/.test(t);
      let ts = isNumQuery ? [] : lookup(t);
      if (!isNumQuery && ALIAS.has(t)) ts = ts.concat(lookup(ALIAS.get(t)).filter(([, q]) => q === 1));
      if (isNum) {
        const n = String(parseInt(t, 10));
        (issueNum.get(n) || []).forEach((i) => bump(i, 60));
        (childNum.get(n) || []).forEach((i) => bump(i, isNumQuery ? 8 : 5));
        if (t.length === 4 && +t >= 1900 && +t <= 2100) {
          const y = +t;
          const only = qt.length === 1;
          for (const e of E) if (e._y && e._y[0] <= y && y <= e._y[1] && (e.k === 'n' || e.k === 'o' || e.k === 'v')) bump(e._i, e.k === 'n' ? (only ? 14 : 5) : (only ? 11 : 4));
        }
      }
      if (!ts.length && !isNum && t.length >= 5) ts = fuzzy(t);
      for (const [term, quality] of ts) {
        matched.push(term);
        for (const [i, w] of post.get(term)) bump(i, w * quality);
      }
      for (const [i, s] of cand) {
        total.set(i, (total.get(i) || 0) + s);
        hits.set(i, (hits.get(i) || 0) + 1);
      }
    });

    const need = qt.length;
    let approx = false;
    let pick = [...hits].filter(([, h]) => h >= need).map(([i]) => i);
    if (!pick.length && need > 1) {
      approx = true;
      pick = [...hits].filter(([, h]) => h >= need - 1).map(([i]) => i);
    }
    const items = [];
    const phrase = f.replace(/[^a-z0-9]+/g, ' ').trim();
    for (const i of pick) {
      const e = E[i];
      if (opts.filter && !opts.filter(e)) continue;
      let s = total.get(i) + (KIND_BONUS[e.k] || 0);
      const ft = fold(e.t).replace(/[^a-z0-9]+/g, ' ').trim();
      const fte = e.te ? fold(e.te).replace(/[^a-z0-9]+/g, ' ').trim() : '';
      if (phrase.length > 2) {
        if (ft === phrase || fte === phrase) s += 20;
        else if (ft.startsWith(phrase) || fte.startsWith(phrase)) s += 10;
        else if (ft.includes(phrase) || fte.includes(phrase)) s += 6;
        const fa = e.a ? fold(e.a).replace(/[^a-z0-9]+/g, ' ').trim() : '';
        if (fa && (fa === phrase || fa.includes(phrase))) s += 6;
      }
      // a igualdad, lo más reciente primero
      const n = e.k === 'n' ? e._n[0] : e._p && e._p.k === 'n' ? nums(e._p.n)[0] : 0;
      s += (n ? +n : 0) / 10000;
      items.push({ e, score: s });
    }
    items.sort((a, b) => b.score - a.score);

    // Personas cuyo nombre contiene todas las palabras buscadas (al menos tres letras)
    let ppl = [];
    if (!isNumQuery && qt.every((t) => t.length >= 3 && !/^\d+$/.test(t))) {
      ppl = peopleList.filter((p) => qt.every((t) => p.words.some((w) => w.startsWith(t))))
        .map((p) => ({ p, s: p.num * 3 + p.obra + p.texto + (p.key === phrase ? 100 : 0) }))
        .filter((x) => x.p.num + x.p.obra + x.p.texto > 1)
        .sort((a, b) => b.s - a.s).slice(0, 6).map((x) => x.p);
    }
    return { items, tokens: qt, terms: matched, approx, numberQuery: isNumQuery, people: ppl };
  }

  return { search, entries: E, cats, byHandle: (h) => byH.get(h) || null, size: E.length };
}

// Resalta (con <mark>) las palabras que empiezan por lo buscado o que son una de las encontradas (erratas).
// Devuelve HTML escapado.
function highlight(text, tokens, terms) {
  const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const src = String(text == null ? '' : text);
  if (!tokens || !tokens.length) return esc(src);
  const re = /[\p{L}\p{N}]+/gu;
  let out = '', last = 0, m;
  while ((m = re.exec(src))) {
    const w = fold(m[0]);
    const hit = tokens.some((t) => t && w.startsWith(t)) || (terms && terms.indexOf(w) >= 0);
    out += esc(src.slice(last, m.index)) + (hit ? '<mark>' + esc(m[0]) + '</mark>' : esc(m[0]));
    last = m.index + m[0].length;
  }
  return out + esc(src.slice(last));
}

const ECSearchCore = { createSearch, highlight, fold, words };

window.ECSearch = ECSearchCore;
})();
